<template>
  <div class="main">
    <v-row class="py-2 py-sm-5 px-3 px-sm-10  d-none d-sm-flex" style="border-bottom: 1px solid #f1f1f1" no-gutters align="center" justify="space-between">
      <!--      <span class="">{{ $t('badge') }}租车</span>-->
      <img width="100px" class=" d-none d-sm-flex" src="../assets/title.png" alt="" @click="goto('')">
      <v-col v-if="isJsdom()" class=" d-sm-flex d-none">
        <v-row no-gutters align="center" justify="center" class="seo-a">
          <a :href="`https://only-jdm.com${hreflang}/`">{{$t("home")}}</a>
          <a :href="`https://only-jdm.com${hreflang}/tour`">{{$t("tour")}}</a>
          <a :href="`https://only-jdm.com${hreflang}/searchcar/`">{{$t("vehicleprice")}}</a>
          <a :href="`https://only-jdm.com${hreflang}/shopdetail/`">{{$t("shop")}}</a>
          <a :href="`https://only-jdm.com${hreflang}/board/`">{{$t("messageboard")}}</a>
          <a :href="`https://only-jdm.com${hreflang}/person/`" v-if="$root.login===true||$root.login==='true'" >{{$t("beginners")}}</a>
        </v-row>
      </v-col>
      <v-col v-else class=" d-sm-flex d-none">
        <v-row no-gutters align="center" justify="center">
          <router-link to="/"><v-btn class="pl-5 " text>{{$t("home")}}</v-btn></router-link>
          <router-link to="/tour"><v-btn class="pl-5 " text>{{$t("tour")}}</v-btn></router-link>
          <router-link to="/searchcar/"><v-btn class="pl-5 " text>{{$t("vehicleprice")}}</v-btn></router-link>
          <router-link to="/shopdetail/"><v-btn class="pl-5 " text>{{$t("shop")}}</v-btn></router-link>
          <router-link to="/board/"><v-btn class="pl-5 " text>{{$t("messageboard")}}</v-btn></router-link>
          <router-link to="/person/" v-if="$root.login===true||$root.login==='true'" ><v-btn class="pl-5 " text>{{$t("beginners")}}</v-btn></router-link>
        </v-row>

      </v-col>

      <div class="right-btn">
        <v-row no-gutters align="center" justify="space-between" class=" d-none d-sm-flex">
          <v-select v-model="lang" full-width hide-details dense style="width: 100px" :items="items" append-icon="$dropdown" @change="changeLocale" class="mr-5"></v-select>
          <v-btn v-if="$route.name!=='signup'&&($root.login===false|| $root.login==='false')" elevation="2" rounded dark color="#E22129FF" style="text-transform: none" @click="goto('signup')">{{$t("signup")}}
          </v-btn>
          <v-btn v-if="$route.name!=='signin'&&($root.login===false|| $root.login==='false')" class="ml-1" elevation="2" rounded dark color="#E22129FF" style="text-transform: none" @click="goto('signin')">{{$t("signin")}}
          </v-btn>
          <v-btn v-if="($route.name&&$route.name!=='signin')&&($root.login===true||$root.login==='true')" class="ml-1" elevation="2" rounded dark color="#E22129FF" style="text-transform: none" @click="logOut">{{$t("logout")}}
          </v-btn>
        </v-row>

      </div>

    </v-row>

    <v-app-bar class=" d-block d-sm-none" color="white">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

      <v-toolbar-title style="display: flex;width: 100%;">
        <img width="60px" style="margin-left: 30%" class="" src="../assets/title.png" alt="" @click="goto('')">
      </v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute touchless temporary>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="deep-dark--text text--accent-4">
          <v-list-item>
            <v-list-item-title>
              <v-row no-gutters align="center" justify="space-between" class="d-flex d-sm-none px-4">
                <v-select v-model="lang" full-width hide-details dense style="width: 90px" :items="items" append-icon="$dropdown" @change="changeLocale" class="mr-0"></v-select>
              </v-row>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title @click="goto('')">
              <v-btn color="primary" text>{{$t("home")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title @click="goto('tour')">
              <v-btn color="primary" text>{{$t("tour")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title @click="goto('searchcar')">
              <v-btn color="primary" text>{{$t("vehicleprice")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title @click="goto('shopdetail')">
              <v-btn color="primary" text>{{$t("shop")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="$root.login===true||$root.login==='true'">
            <v-list-item-title @click="goto('person')">
              <v-btn color="primary" text>{{$t("beginners")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-title>
              <v-btn color="primary" @click="goto('feedback')" text>{{$t("feedback")}}</v-btn>
            </v-list-item-title>
          </v-list-item> -->
          <v-list-item>
            <v-list-item-title @click="goto('board')">
              <v-btn color="primary" text>{{$t("messageboard")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="$route.name!=='signup'&&($root.login===false|| $root.login==='false')">
            <v-list-item-title @click="goto('signup')">
              <v-btn color="red darken-1" text>{{$t("signup")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="$route.name!=='signin'&&($root.login===false|| $root.login==='false')">
            <v-list-item-title @click="goto('signin')">
              <v-btn color="red darken-1" text>{{$t("signin")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="($route.name&&$route.name!=='signin')&&($root.login===true||$root.login==='true')">
            <v-list-item-title @click="logOut">
              <v-btn color="red darken-1" text>{{$t("logout")}}</v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
    <v-divider class="mt-4"></v-divider>
    <div class="footer">

      <v-row no-gutters class="mt-0 mt-sm-8" justify="center">
        <div>
          <v-img eager width="100" src="../assets/footer.jpg"></v-img>
        </div>
      </v-row>
      <v-row no-gutters justify="center">
        <a style="margin-left:14px" @click="gotoBusiness">{{$t("specificTrade")}}</a>
      </v-row>
      <v-row no-gutters class="pb-8" justify="center">
        ©2025 J Project Co.,Ltd. all rights reserved.
      </v-row>
      <v-row no-gutters class="pb-8" justify="center">

      </v-row>
    </div>

  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: "layout-view",
  components: {},
  data: () => ({
    drawer: false,
    group: null,
    items: [
      {
        text: "English",
        value: "en",
      },
      {
        text: "日本語",
        value: "ja",
      },
      {
        text: "繁體中文",
        value: "zhHant",
      },
    ],
    lang: "en",
    model: "",
  }),
  computed: {
    hreflang() {
      return this.$i18n.locale === 'en' ? '' : `/${this.$i18n.locale}`
    }
  },
  methods: {
    gotoBusiness() {
      this.$router.push({ path: "/specificbusiness", query: { id: "0" } });
    },
    changeLocale(val) {
      const oldLang = this.$i18n.locale
      this.lang = this.$i18n.locale = val;

      let path = this.$route.path

      if (oldLang === 'en') {
        path = val === 'en' ? this.$route.path : `/${val}${this.$route.path}`
      } else {
        path = val === 'en' ? this.$route.path.replace(`/${oldLang}`, `/`) : this.$route.path.replace(`/${oldLang}`, `/${val}`)
      }

      console.log(this.$route.path, path, oldLang, val, 1111111)

      this.$router.replace({
        path,
        query: {
          ...this.$route.query,
          // lang: val,
        },
      });
      setTimeout(() => {
        location.reload();
      });
    },
    goto(path) {
      this.drawer = false;
      if (this.$router.path === `/${path}`) {
        return;
      }

      this.$router.push(`/${path}`).catch((err) => {
        console.log(err, "err");
      });
    },
    logOut() {
      this.$api
        .fetch("/user/logout", { ordersn: this.ordersn }, { getAll: true })
        .then((res) => {
          if (res.code == 1) {
            this.$root.login = false;
            localStorage.removeItem('login')
          }
        });
    },
    isJsdom() {
      return navigator.userAgent.includes('jsdom')
    }
  },
  created() {
    console.log(this.$router);
    if (this.$route.params.lang) {
      this.$i18n.locale = this.lang = this.$route.params.lang;
    }
  },
};
</script>
<style scoped lang="scss">
.nav-list {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, #555555 40%, #333333 70%);
}

.max-width-1000 {
  max-width: 1000px;
  background: linear-gradient(to bottom, #555555 40%, #333333 70%);
}

.title-img-xs {
  width: 165px;
  height: 37.7px;
}

.title-img {
  width: 280px;
  height: 64px;
}

.h100 {
  height: 100%;
}

@media screen and (max-width: 600px) {
  .main {
    padding-bottom: 200px !important;
  }
}
.main {
  padding-bottom: 200px;
}

.footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.seo-a {
  a {
    color: #000;
    text-decoration: none;
    height: 36px;
    line-height: 36px;
    min-width: 64px;
    padding: 0 16px;
    font-weight: 500;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    letter-spacing: .0892857143em;
  }
}
</style>
<style lang="scss">
.v-input__slot {
  &:before {
    display: none;
  }

  &:after {
    display: none;
  }
}
</style>
